<emm-management-layout>
    <emm-search-filter [addDialog]="true" [displaySearchWithOptions]="false" [fields]="fields$ | async"
        layout-center-header (add)="openPinOverridesDialog()" (filter)="onFilter($event)"
                       [isAdminOrAuthor]="this.isAdmin || this.isAuthor"
                       [isSuperAdmin]="this.isSuperAdmin"
    ></emm-search-filter>
    <emm-generic-items-list [contextMenuActions]="pinOverrideGroupsContextMenuActions"
                            [isReadOnly]="isReadOnly$ | async"
                            [items]="pinOverridesAsGenericItems$ | async" layout-center-content
                            [changeOnSelect] = "false"
                            [selectedItem]="selectedGeneric"
                            (onSelectItem)="onSelectPinOverrideGroup($event);"></emm-generic-items-list>
    <div>test: {{ (selectedPinOverrideGroup$ | async)?.id }} |</div>
    <emm-management-attributes-header *ngIf="(selectedPinOverrideGroup$ | async) as group" layout-right-header [name]="group.name"
        [tag]="" [description]="group.description"></emm-management-attributes-header>
    <emm-pin-overrides-form #form layout-right-content
        [selected]="selectedPinOverrideGroup$"
        [managementFacade]="managementFacade"
        [next]="this.pinOverrides$.next"
        [getPinOverrides]="this.getPinOverrides"
        [locationSetTypes$]="locationSetTypes$"
        [isSuperAdmin]="isSuperAdmin"
        [isAdmin]="isAdmin"
        (isRestoreVisible)="setRestoreVisible($event)"
        (areEditButtonsVisible)="setEditButtonsVisible($event)"
        (invalidRmi)="handleRmiValidation($event)"></emm-pin-overrides-form>
    <emm-management-attributes-footer *ngIf="(selectedPinOverrideGroup$ | async)"
                                      [disableCancel]="!pinOverridesForm || !pinOverridesForm.hasChanges()"
                                      [disableUpdate]="!pinOverridesForm || !pinOverridesForm.hasChanges() || invalidRmi"
                                      [publishPinsToggle]="publishPinsToggle$ | async" [hasPins]="(pinOverrides$ | async)?.length > 0"
                                      [isRestoreVisible]="isRestoreVisible" [areEditButtonsVisible]="areEditButtonsVisible"
                                      [isPinOverrideGroupActive]="isSelectedGroupActive | async"
                                      layout-right-footer
                                      (cancel)="pinOverridesForm.cancel()" (submit)="pinOverridesForm.submit()"
                                      (restore)="pinOverridesForm.openConfirmRestorePinsDialog()"
                                      (publish)="publishAllPins()"
                                      (forceOverride)="handleForceOverride()"
                                      class="pin-overrides-footer"
        ></emm-management-attributes-footer>
</emm-management-layout>
